import axios from "axios";
import Swal from "sweetalert2";
import { store } from "../redux/store";
import {refreshAccessToken } from "./authService";
import { updateAccessToken, updateRefreshToken, logout } from "../redux/slicers/authSlice";
import { message } from "antd";
import { t } from "i18next";


export const axiosInstanceWithToken = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

const excludedRoutes = ["/auth/login", "/auth/register", "/auth/refresh"];
let isRefreshing = false;
let failedQueue: any[] = [];

const processQueue = (error: any, token: string | null = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

// ✅ Request Interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const token = store.getState().authSlice.accessToken;

    if (
      token &&
      config.url &&
      !excludedRoutes.some(route => config.url?.includes(route))
    ) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Response Interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      !excludedRoutes.some(route => originalRequest.url?.includes(route))
    ) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({
            resolve: (token: string) => {
              originalRequest.headers.Authorization = `Bearer ${token}`;
              resolve(axiosInstance(originalRequest));
            },
            reject: (err: any) => reject(err),
          });
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const { newAccessToken, newRefreshToken } = await refreshAccessToken();

      
        store.dispatch(updateAccessToken(newAccessToken));
        store.dispatch(updateRefreshToken(newRefreshToken));

        axiosInstance.defaults.headers.common.Authorization = `Bearer ${newAccessToken}`;
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;

        processQueue(null, newAccessToken);
        return axiosInstance(originalRequest);
      } catch (refreshError : any) {
        processQueue(refreshError, null);
        store.dispatch(logout());

        Swal.fire({
          icon: "warning",
          title: t("session_expired"),
          text: t("please_login_again"),
        });

        return  Promise.reject(error);
      } finally {
        isRefreshing = false;
      }
    }
    console.log("error", error);

    // Optional: show alert for other errors
    if (error.response && error.response.data?.message) {
      console.log("error.response.data.message", error.response.data.message);
      const messageError = error?.response?.data?.code ? t("errors." + error?.response?.data?.code) : error.response.data.message ?? t("error_occurred");
      message.error(messageError);
    }else{
      message.error(t("error_occurred"));
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
